module.exports = __webpack_public_path__ + "static/media/sl.9fef0063.svg";